import React, { useEffect, useState } from 'react';
import { Container, Typography, List, ListItem, ListItemText, CircularProgress, Button } from '@mui/material';
import BackButton from '../BackButton';
import { useParams } from 'react-router-dom';

export default function GroupPage() {
  const { groupId } = useParams();
  const [loading, setLoading] = useState(true);
  const [group, setGroup] = useState(null);

  useEffect(() => {
    setLoading(true);
    // TODO: Fetch group info from backend
    setTimeout(() => {
      setGroup({
        id: groupId,
        name: 'Fishing Buddies',
        members: [
          { user_id: 1, nickname: 'Alice', role: 'admin' },
          { user_id: 2, nickname: 'Bob', role: 'user' },
        ],
      });
      setLoading(false);
    }, 1000);
  }, [groupId]);

  return (
    <Container maxWidth="sm" sx={{ mt: 4, position: 'relative' }}>
      <BackButton sx={{ position: 'absolute', top: 8, left: 8 }} />
      <Typography variant="h5" align="center" gutterBottom>Group: {group?.name}</Typography>
      {loading ? <CircularProgress sx={{ display: 'block', mx: 'auto', my: 4 }} /> : (
        <>
          <List>
            {group.members.map(member => (
              <ListItem key={member.user_id}>
                <ListItemText primary={member.nickname} secondary={member.role} />
              </ListItem>
            ))}
          </List>
          <Button variant="contained" sx={{ mt: 2 }}>Invite Member</Button>
        </>
      )}
    </Container>
  );
}
